import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box, Stack, Heading, Text } from "braid-design-system";
import { JDVLayout } from "./styles/components/JDVLayout/JDVLayout.mjs";
import { JobDetailsPreview } from "./styles/components/JobDetailsPreview/JobDetailsPreview.mjs";
import { JobDetailsView } from "./styles/components/JobDetailsView/JobDetailsView.mjs";
import { OptionsBar } from "./styles/components/OptionsBar/OptionsBar.mjs";
import { ShareMenu } from "./styles/components/ShareMenu/ShareMenu.mjs";
const paragraph = () => /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(Box, { background: "neutralLight", borderRadius: "small", width: "full", children: /* @__PURE__ */ jsx(Text, { children: " " }) }),
  /* @__PURE__ */ jsx(
    Box,
    {
      background: "neutralLight",
      borderRadius: "small",
      style: { width: "160px", maxWidth: "100%" },
      children: /* @__PURE__ */ jsx(Text, { children: " " })
    }
  )
] });
const JobDetailsMockup = ({
  highlightApplyButton = true,
  showMainContent = true,
  ...props
}) => {
  const applyButtonBackgroundColour = highlightApplyButton ? "brandAccent" : "neutralLight";
  return /* @__PURE__ */ jsx(
    JDVLayout,
    {
      ...props,
      applyAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: applyButtonBackgroundColour,
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "142px" } })
        }
      ),
      saveAction: /* @__PURE__ */ jsx(
        Box,
        {
          background: "neutralLight",
          borderRadius: "standard",
          height: "touchable",
          children: /* @__PURE__ */ jsx("div", { style: { width: "120px" } })
        }
      ),
      header: /* @__PURE__ */ jsxs(Stack, { space: { mobile: "small", tablet: "medium" }, children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "380px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Heading, { component: "span", level: "1", children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "250px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { size: "large", children: " " })
          }
        )
      ] }),
      headerAdditional: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "205px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "190px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            background: "neutralLight",
            borderRadius: "small",
            style: { width: "220px", maxWidth: "100%" },
            children: /* @__PURE__ */ jsx(Text, { children: " " })
          }
        )
      ] }) }),
      mainContent: showMainContent && /* @__PURE__ */ jsx(Stack, { space: "large", children: [1, 1, 1].map(() => paragraph()) }),
      menu: /* @__PURE__ */ jsx("span", {}),
      jobTitle: "",
      companyName: ""
    }
  );
};
const match = "Match";
const missingSalaryPreference = "Missing Salary Preference";
const getIsSalaryMatch = (salaryMatchLabel) => salaryMatchLabel === match;
const getIsCandidateSetSalary = (salaryMatchLabel) => salaryMatchLabel !== missingSalaryPreference;
const isJobProfileSalaryMatch = (candidateSalaryMatch) => candidateSalaryMatch.salaryPreference !== void 0;
const getJobProfileSalaryMatch = (candidateSalaryMatch) => {
  if (candidateSalaryMatch && isJobProfileSalaryMatch(candidateSalaryMatch)) {
    const salaryMatchPreference = candidateSalaryMatch.salaryPreference;
    return {
      salaryCountryName: salaryMatchPreference.country.name,
      salaryExpectation: `${salaryMatchPreference.currencyCode} ${salaryMatchPreference.amount} ${salaryMatchPreference.salaryType}`
    };
  }
};
const useSalaryMatch = (candidateSalaryMatch) => {
  var _a, _b;
  const isSalaryMatch = getIsSalaryMatch(candidateSalaryMatch == null ? void 0 : candidateSalaryMatch.label);
  const isCandidateSetSalary = getIsCandidateSetSalary(
    candidateSalaryMatch == null ? void 0 : candidateSalaryMatch.label
  );
  const salaryMatchCountryName = (_a = getJobProfileSalaryMatch(candidateSalaryMatch)) == null ? void 0 : _a.salaryCountryName;
  const salaryExpectation = (_b = getJobProfileSalaryMatch(candidateSalaryMatch)) == null ? void 0 : _b.salaryExpectation;
  return {
    isSalaryMatch,
    isCandidateSetSalary,
    salaryExpectation,
    salaryMatchCountryName
  };
};
const useJobDetailsProps = ({
  jobDetails,
  jobApplyUrl,
  flags,
  topApplicant,
  salaryMatch
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const {
    job,
    sourcr,
    companyProfile,
    companyReviews,
    companySearchUrl,
    companyTags,
    restrictedApplication
  } = jobDetails;
  const {
    advertiser,
    classifications,
    contactMatches,
    content,
    id,
    isExpired,
    isLinkOut,
    isVerified,
    listedAt,
    location,
    products,
    salary,
    title,
    workTypes,
    phoneNumber,
    shareLink
  } = job;
  const { branding, questionnaire, video } = products || {};
  const getProfileUrl = (companyNameSlug) => companyNameSlug ? `/companies/${companyNameSlug}` : void 0;
  const getReviewsUrl = (companyNameSlug, jobId) => companyNameSlug && jobId ? `/companies/${companyNameSlug}/reviews?jobId=${jobId}` : void 0;
  const {
    isSalaryMatch,
    isCandidateSetSalary,
    salaryExpectation,
    salaryMatchCountryName
  } = useSalaryMatch(salaryMatch);
  return {
    job: {
      id,
      appliedDateFormatted: flags.appliedDateFormatted,
      applyUrl: jobApplyUrl,
      shareLink,
      branding: branding ? {
        assets: {
          ...((_a = branding == null ? void 0 : branding.cover) == null ? void 0 : _a.url) && {
            cover: {
              id: "",
              strategies: {
                jdpCover: (_b = branding == null ? void 0 : branding.cover) == null ? void 0 : _b.url
              },
              url: (_c = branding == null ? void 0 : branding.cover) == null ? void 0 : _c.url
            }
          },
          logo: {
            id: "",
            strategies: {
              jdpLogo: (_d = branding == null ? void 0 : branding.logo) == null ? void 0 : _d.url
            },
            url: (_e = branding == null ? void 0 : branding.logo) == null ? void 0 : _e.url
          }
        }
      } : void 0,
      classifications: classifications.map(
        (classification) => classification.label
      ),
      company: {
        name: advertiser == null ? void 0 : advertiser.name,
        jobsSearchUrl: companySearchUrl,
        ...companyReviews && {
          profileUrl: companyReviews == null ? void 0 : companyReviews.reviewsUrl.replace(/\/reviews.*/, ""),
          reviews: {
            count: companyReviews == null ? void 0 : companyReviews.reviewCount,
            rating: companyReviews == null ? void 0 : companyReviews.rating,
            reviewsUrl: companyReviews == null ? void 0 : companyReviews.reviewsUrl
          }
        },
        ...companyTags && {
          tags: companyTags
        }
      },
      companyProfile: companyProfile ? {
        logo: ((_f = companyProfile.branding) == null ? void 0 : _f.logo) ?? void 0,
        profileUrl: getProfileUrl(companyProfile.companyNameSlug),
        reviewsUrl: getReviewsUrl(companyProfile.companyNameSlug, id),
        id: companyProfile.id,
        name: companyProfile.name,
        overview: {
          industry: ((_g = companyProfile.overview) == null ? void 0 : _g.industry) ?? void 0,
          companySize: (_i = (_h = companyProfile.overview) == null ? void 0 : _h.size) == null ? void 0 : _i.description,
          companyDescription: (_k = (_j = companyProfile.overview) == null ? void 0 : _j.description) == null ? void 0 : _k.paragraphs
        },
        perksAndBenefits: companyProfile.perksAndBenefits.map(
          (perk) => perk.title
        ),
        ...((_l = companyProfile.reviewsSummary) == null ? void 0 : _l.overallRating) && {
          overallRating: {
            rating: companyProfile.reviewsSummary.overallRating.value,
            reviewCount: companyProfile.reviewsSummary.overallRating.numberOfReviews.value
          }
        },
        shouldDisplayReviews: companyProfile.shouldDisplayReviews
      } : void 0,
      contactMatches,
      currencyLabel: salary == null ? void 0 : salary.currencyLabel,
      description: content,
      employerQuestions: (questionnaire == null ? void 0 : questionnaire.questions) ?? [],
      isExpired,
      isLinkOut,
      isSaved: Boolean(flags == null ? void 0 : flags.isSaved),
      isVerified,
      location: location == null ? void 0 : location.label,
      postedDateFormatted: listedAt == null ? void 0 : listedAt.label,
      restrictedApplication,
      salary: salary == null ? void 0 : salary.label,
      isSignedIn: Boolean(flags == null ? void 0 : flags.isAuthenticated),
      isSalaryMatch,
      isCandidateSetSalary,
      salaryExpectation,
      salaryMatchCountryName,
      sourcr: sourcr ? {
        imageSrc: sourcr.image,
        imageMobileSrc: sourcr.imageMobile,
        profileUri: sourcr.link
      } : void 0,
      title,
      topApplicant,
      video: video && {
        link: video == null ? void 0 : video.url,
        position: video == null ? void 0 : video.position
      },
      workType: workTypes == null ? void 0 : workTypes.label,
      phoneNumber
    }
  };
};
const JOB_DISPLAY_TYPE_QUERY_KEY = "type";
export {
  JOB_DISPLAY_TYPE_QUERY_KEY,
  JobDetailsMockup,
  JobDetailsPreview,
  JobDetailsView,
  OptionsBar,
  ShareMenu,
  useJobDetailsProps
};
